import { Link } from "react-router-dom";
import { DELETED_COMMENT_TEXT } from "../../hooks/useCommentsStore";
import { formatPostTimestamp } from "../../utils/formatPostTimestamp";
import CommentInteractionBar from "./CommentInteractionBar";
import MentionText from "../mentions/MentionText";

const DEFAULT_AVATAR = `${process.env.PUBLIC_URL}/logo512.png`;

// One comment. A deleted comment renders as an anonymous placeholder with no
// author, avatar, or controls; its replies are still rendered by the caller.
export default function CommentRow({
  comment,
  isOwn,
  canReply,
  canInteract,
  canEditOwn,
  canDeleteOwn,
  canRemoveOwn,
  isReactionPending,
  onReply,
  onEdit,
  onDelete,
  onToggleLike,
  onReact,
}) {
  if (comment.is_deleted) {
    return (
      <div className="flex items-start gap-2 py-1.5">
        <div className="w-5 h-5 rounded-full bg-gray-200 flex-shrink-0" aria-hidden="true" />
        <p className="text-sm italic text-gray-500">{DELETED_COMMENT_TEXT}</p>
      </div>
    );
  }

  return (
    <div className="flex items-start gap-2 py-1.5">
      <Link to={`/profiles/${comment.user}`} className="flex-shrink-0" tabIndex={-1} aria-hidden="true">
        <img
          src={comment.profile_pic_url || DEFAULT_AVATAR}
          alt=""
          className="w-5 h-5 rounded-full object-cover border border-black"
        />
      </Link>
      <div className="min-w-0 flex-1">
        <p className="text-sm break-words whitespace-pre-wrap">
          <Link to={`/profiles/${comment.user}`} className="font-semibold hover:underline">
            {comment.user}
          </Link>{" "}
          <MentionText text={comment.text} mentions={comment.mentions} />
        </p>
        <p className="text-[11px] text-gray-400">
          <time dateTime={comment.created_at}>{formatPostTimestamp(comment.created_at)}</time>
        </p>
        <CommentInteractionBar
          comment={comment}
          canInteract={canInteract}
          canRemoveOwn={canRemoveOwn}
          isReactionPending={isReactionPending}
          onToggleLike={onToggleLike}
          onReact={onReact}
          onReply={canReply ? onReply : null}
          onEdit={isOwn && canEditOwn ? onEdit : null}
          onDelete={isOwn && canDeleteOwn ? onDelete : null}
        />
      </div>
    </div>
  );
}
